import {Injectable} from "@angular/core";

import {ApiService} from "app/services/domain/api.service";
import * as Models from "app/services/proxy/model/models";

@Injectable()
export class AttachmentsService
{
    constructor(private m_api: ApiService)
    {}

    public async uploadAttachment(file: File): Promise<Models.Attachment>
    {
        if (!file) return null;
        
        let attachment = Models.Attachment.newInstance({
                                                           name     : file.name,
                                                           file_name: file.name
                                                       });

        attachment = await this.m_api.attachments.create(attachment);
        if (!attachment) return null;

        attachment = await this.m_api.attachments.upload(attachment.id, file);
        attachment.description ??= `${attachment.name}${FILE_SIZE_ENCODER}${file.size}`;

        return attachment.id ? attachment : null;
    }

    public async getAttachment(attachmentId: string): Promise<Models.Attachment>
    {
        return this.m_api.attachments.get(attachmentId);
    }

    public async downloadAttachment(attachmentId: string, fileName: string): Promise<Blob>
    {
        return this.m_api.attachments.download(attachmentId, fileName);
    }
}

export const FILE_SIZE_ENCODER = "_#_";
